import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

const AgentsManagementPanel = () => {
  const [agents, setAgents] = useState([]);
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/agents`);
      setAgents(data.agents || []);
    } catch (_e) { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault();
    setErr(''); setMsg('');
    try {
      await axios.post(`${API}/admin/agents`, { username: username.trim(), password, name: name.trim() });
      setMsg(`Ο λογαριασμός «${username}» δημιουργήθηκε.`);
      setUsername(''); setName(''); setPassword('');
      load();
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Σφάλμα δημιουργίας');
    }
  };

  const remove = async (u) => {
    if (!window.confirm(`Διαγραφή αντιπροσώπου «${u}»;`)) return;
    try { await axios.delete(`${API}/admin/agents/${encodeURIComponent(u)}`); load(); } catch (_e) { /* ignore */ }
  };

  return (
    <div className="rounded-2xl p-5 md:p-6" style={{ background: 'rgba(12,22,40,0.6)', border: '1px solid rgba(201,168,76,0.3)' }} data-testid="agents-management-panel">
      <h3 className="text-gold text-lg font-bold mb-1" style={{ fontFamily: 'Georgia, serif' }}>Αντιπρόσωποι / Υπάλληλοι</h3>
      <p className="text-slate-400 text-xs mb-4">Δημιουργήστε λογαριασμούς που θα χειρίζονται τα live chat. Σύνδεση στο <span className="text-gold">/agent</span></p>

      <form onSubmit={create} className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4" data-testid="agent-create-form">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Όνομα" className="px-3 py-2 rounded-lg bg-navy-200/60 border border-slate-700 text-white text-sm focus:border-gold outline-none" data-testid="new-agent-name" />
        <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" required className="px-3 py-2 rounded-lg bg-navy-200/60 border border-slate-700 text-white text-sm focus:border-gold outline-none" data-testid="new-agent-username" />
        <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required className="px-3 py-2 rounded-lg bg-navy-200/60 border border-slate-700 text-white text-sm focus:border-gold outline-none" data-testid="new-agent-password" />
        <button type="submit" className="py-2 rounded-lg font-semibold text-navy text-sm" style={{ background: 'linear-gradient(180deg,#d4b661,#a17f2f)' }} data-testid="create-agent-btn">Δημιουργία</button>
      </form>
      {msg && <p className="text-green-400 text-sm mb-2" data-testid="agent-create-success">{msg}</p>}
      {err && <p className="text-red-400 text-sm mb-2" data-testid="agent-create-error">{err}</p>}

      <div className="space-y-2" data-testid="agents-list">
        {agents.length === 0 && <p className="text-slate-500 text-sm">Δεν υπάρχουν αντιπρόσωποι ακόμη.</p>}
        {agents.map((a) => (
          <div key={a.username} className="flex items-center justify-between px-4 py-2.5 rounded-lg bg-navy-200/40 border border-slate-700/60" data-testid={`agent-row-${a.username}`}>
            <div>
              <span className="text-white text-sm font-medium">{a.name || a.username}</span>
              <span className="text-slate-500 text-xs ml-2">@{a.username}</span>
            </div>
            <button onClick={() => remove(a.username)} className="text-red-400 hover:text-red-300 text-xs border border-red-400/40 rounded px-3 py-1" data-testid={`delete-agent-${a.username}`}>Διαγραφή</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgentsManagementPanel;
